module.exports = __webpack_public_path__ + "img/8.a62fa3fa.jpg";